<template>
    <transition name="fade" mode="out-in">
        <div v-show="myActive && show" role="tabpanel" class="tab-pane" :class="{active:myActive}">
            <slot></slot>
        </div>
    </transition>
</template>
<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

</style>
<script>
    export default{
        name: 'c-tabpage',
        data() {
            return {
                active: false,
                myActive: false,
                dirty: true,
                allwatcher: []
            };
        },
        props: {
            show: {
                default: true
            },
            title: {
                require: true,
                default: 'tabpage'
            },
            icon: {
                default: ''
            }
        },
        mounted() {
            var vm = this;
            // for (var i = 0; i < vm.$children.length; i++) {
            //     var c=vm.$children[i];
            //     var watchers=c._watchers;
            // }
            vm.changeTab();
        },
        methods: {
            invokeMethod(methodName, params) {
                if (methodName) {
                    var vm = this;
                    for (var i = 0; i < vm.$children.length; i++) {
                        var c = vm.$children[i];
                        if (c.$options.tabevents && c.$options.tabevents[methodName]) {
                            if (params instanceof Array) {
                                c.$options.tabevents[methodName].apply(c, params);
                            } else {
                                c.$options.tabevents[methodName].call(c, params);
                            }
                        }
                    }
                }
            },
            changeTab() {
                var vm = this;
                if (vm.active) {
                    vm.invokeMethod('beforeShow');
                } else {
                    vm.invokeMethod('beforeHide');
                }
                vm.myActive = vm.active;
                vm.invokeMethod('changeActive', vm.myActive);
                vm.$nextTick(function () {
                    if (vm.active) {
                        vm.invokeMethod('afterShow');
                    } else {
                        vm.invokeMethod('afterHide');
                    }
                });
            }
        },
        watch: {
            'active': function () {
                var vm = this;
                vm.changeTab();
            },
            'show': function () {
                var vm = this;
                vm.$emit('showChange', vm.show);
            }
        }

    }
</script>



// WEBPACK FOOTER //
// tabpage.vue?077d48fc